import React from 'react';

type Props = {
    text: string;
    delayStep?: number;
    className?: string;
};

const CharacterStagger: React.FC<Props> = ({
    text,
    delayStep = 0.01,
    className = '',
}) => {
    return (
        <span
            className={`btn-animate-chars__text ${className}`}
            aria-label={text}
        >
            <span data-button-animate-chars aria-hidden="true">
                {[...text].map((char, i) => (
                    <span
                        key={`${char}-${i}`}
                        style={{
                            transitionDelay: `${i * delayStep}s`,
                            whiteSpace: char === ' ' ? 'pre' : undefined,
                        }}
                    >
                        {char}
                    </span>
                ))}
            </span>
            <span className="sr-only">{text}</span>
        </span>
    );
};

export default CharacterStagger;
